(async () => {
    const {
      updateURLParams,
      historyPush,
      parseHTML,
      getParentSection
    } = await import(window.theme.modules.utils);
    
    const isEqual = (arr1, arr2) => arr1.toString() === arr2.toString();
    const strEsc = (str) => str.replace(/["\\]/g, '\\$&');
    const parseJSON = (el) => JSON.parse(el.textContent)
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('product-variant-selector', class extends baseComponent.default {
      elements = {
        variantsJSON: '[data-variants-json]',
        optionsJSON: '[data-options-with-values]'
      };
      
      render() {
        this.cache = {};
        this.isProductPage = this.hasAttribute('product-page');
        this.variantsData = parseJSON(this.$variantsJSON);
        this.optionsData = parseJSON(this.$optionsJSON);
        this.optionsData[0].values.unshift('Select Colour');
        this._getDefaultVariant();
        this._checkUnavailable();
        this.addEventListener('change', this._variantChangeHandler.bind(this));
        this.on('qtyStatusUpdate', (e, data) => {
          this.cache[+data.variantId] = data.html.outerHTML
        }, false)
        this._setInititalCache();
      };
  
      _getDefaultVariant() {
        this.variant = this.variantsData.find(v => v.id === +this.getAttribute('current-variant-id'));
        if(this.getAttribute('selected-variant-id') == ''){
          this.variant.id = 100000;
          //this.variant.option1 = 'Select Colour';
          //this.variant.options[0] = 'Select Colour';
          this.variant.featured_image.position=0;
          this._variantChangeHandler({target: {name: 'Color', value: 'Select Colour', hasAttribute: ()=>{}}});
          this._toogleInputs({name: 'Color', value: 'Select Colour', hasAttribute: ()=>{}});
          addEventListener("load", (event) => {
            ////document.querySelector("slide-show").slideTo(0);
            window.thumb_slider_timer = setInterval(()=>{
              if(!window.thumb_slider_counter){
                window.thumb_slider_counter = 0;
                window.thumb_slides = [];
                const items = document.querySelectorAll('slideshow-thumbnails [data-item]');
                for(let x = 0; x < items.length; x++){
                  if(items[x].style.display != "none"){
                    window.thumb_slides.push(items[x]);
                  }
                }
              }

              for(let x = 0; x < window.thumb_slides.length; x++){
                ///window.thumb_slides[x].classList.remove("!active");
              }
              for(let x = 0; x < window.thumb_slides.length; x++){
                ///console.log(window.thumb_slides[x]);
                if(window.thumb_slider_counter > window.thumb_slides.length) window.thumb_slider_counter = 0;
                if(window.thumb_slider_counter == x){
                  //window.thumb_slides[x].classList.add("!active");
                  if(window.innerWidth > 1000)window.slider.slideTo(window.thumb_slides[x].getAttribute("data-item"));
                }
              }
              //console.log(window.thumb_slider_counter);
              window.thumb_slider_counter++;
            }, 1500);
          });
        }
      };

      _setInititalCache() {
        const parentSection = this.getParentSection();
        this.cache[this.variant.id] = parentSection.outerHTML;
      };
  
      _checkUnavailable() {
        this.optionsData.map((option, i) => {
          let optionsToCheck = [...this.variant.options];
          option.values.map(optionValue => {
            optionsToCheck[i] = optionValue;
            if(optionValue == 'Select Colour') return;
            const match = this._findVariantByOptions(optionsToCheck);
            this._toggleOption(option.name, optionValue, !match);   
          })

        })
      };
  
      _toggleOption(name, value, disable) {
        const targetInput = this.querySelector(`[name="${strEsc(name)}"][value="${strEsc(value)}"`);
        disable
          ? targetInput.setAttribute('data-unavailable', '')
          : targetInput.removeAttribute('data-unavailable');
      };
  
      _variantChangeHandler(e) {
        if (!e.detail?.synthetic) {
            this._selectVariantByOption(e.target);
              const { queryURL, currentURL } = updateURLParams({ 'variant': this.variant.id }, this.sectionId, window.location.origin + this.getAttribute('product-url'));
              if (this.isProductPage) historyPush(currentURL);

            this._checkUnavailable();

          if(e.target.value == 'Select Colour'){
            ///document.querySelector('[data-add-to-list]').setAttribute("disabled", true);
            window.current_variant = product.variants[0];
            return;
          }
          document.querySelector('[data-add-to-list]').removeAttribute("disabled");
          const variantId = this.variant.id == 100000 ? product.variants[0].id : this.variant.id;
          window.current_variant = variantId;
          document.querySelector('product-form form [name="id"]').value = variantId;
          return;

            const cached = this.cache[variantId];
            // console.log(cached);
            // console.log(this.cache);

            if (cached) {
              this.forwardEvent('variantChange', {
                  html: parseHTML(cached),
                  variant: this.variant
              })
            } else {
              this._fetchPageWithVariant(queryURL, (html) => {
                this.cache[variantId] = html;
                this.forwardEvent('variantChange', {
                        html: parseHTML(html),
                        variant: this.variant
                    })
                });
            }
            
        }  
      };
  
      _selectVariantByOption(target) {
        if(target.value == 'Select Colour'){
          this.variant.id = 100000;
          return;
        }
        let valueIndex = this.optionsData.findIndex(option => option.name === target.name);
        if (target.hasAttribute('data-unavailable')) {
          this.variant = this.variantsData.find(variant => variant.options[valueIndex] === target.value);
          this._toogleInputs(target)
        } else {
          let optionsToFind = [...this.variant.options];
          optionsToFind[valueIndex] = target.value;
          this.variant = this._findVariantByOptions(optionsToFind);
        }
      };
  
     _toogleInputs(target) {
          //console.log('window.thumb_slides:', window.thumb_slides);
          //console.log('target:', target);
      
          if (window.thumb_slider_timer) {
              clearInterval(window.thumb_slider_timer);

              if (window.thumb_slides && Array.isArray(window.thumb_slides) && window.thumb_slides.length) {
                  for (let x = 0; x < window.thumb_slides.length; x++) {
                      window.thumb_slides[x].classList.remove("!active");
                  }
              } else {
                  console.warn('window.thumb_slides is not initialized or not an array.');
              }
      
              window.thumb_slider_timer = null;
          }
      
          if (!target || typeof target.value === 'undefined' || typeof target.name === 'undefined') {
              console.error('Invalid target passed to _toogleInputs:', target);
              return;
          }
      
          if (target.value === 'Select Colour') {
              const input = this.querySelector(`input[value="Select Colour"][name="Color"]`);
              if (input && !input.checked) {
                  input.checked = true;
                  input.dispatchEvent(
                      new CustomEvent('change', { bubbles: true, detail: { synthetic: true } })
                  );
              } else {
                  console.warn('No input found for "Select Colour".');
              }
              return;
          }
      
          const input = this.querySelector(
              `input[value="${strEsc(target.value)}"][name="${strEsc(target.name)}"]`
          );
          if (input && !input.checked) {
              input.checked = true;
              input.dispatchEvent(
                  new CustomEvent('change', { bubbles: true, detail: { synthetic: true } })
              );
          } else if (!input) {
              console.warn(
                  `No input found for value="${strEsc(target.value)}" and name="${strEsc(target.name)}".`
              );
          }
      }
  
      _findVariantByOptions(options) {
        return this.variantsData.find(variant => isEqual(variant.options, options));
      };
  
      _updateSwatchLable(swatchInput) {
        swatchInput.closest('product-variant-swatch').querySelector('[data-swatch-value]').textContent = swatchInput.value;
      };
  
      _fetchPageWithVariant(url, onResponse) {
        this.forwardEvent('variantLoading');
        return fetch(url)
        .then(response => response.text())
        .then(responseText => {
          onResponse(responseText);
        });
      };    
    });

    customElements.define('product-option-picker', class extends baseComponent.default {
        elements = {
            value: '[data-option-value]'
        }
        render() {
          window.optionPicker = this;
            this.addEventListener('change', e => {
                if(this.$value) {
                    this.$value.innerText = e.target.value;
                }
              ////return;///////////////////////////////////////////////////
                console.log(window.slider.getCurrentSlide());
                if(e.target.value == 'Select Colour'){
                  //document.querySelector('[data-add-to-list]').setAttribute("disabled", true);
                  
                  if(positions.includes(window.slider.getCurrentSlide() + 1)){
                    window.slider.slideTo(0);
                  }
                  
                }else{
                  document.querySelector('[data-add-to-list]').removeAttribute("disabled");
                  let variant = '';
                  for(let i = 0; i < product.variants.length; i++){
                    if(product.variants[i].option1 == e.target.value){
                      variant = product.variants[i];
                    }
                  }
                  if(variant && variant.featured_media.position != (window.slider.getCurrentSlide() + 1)){
                    console.log(variant.featured_media.position, window.slider.getCurrentSlide());
                    window.slider.slideTo(variant.featured_media.position - 1);
                  }
                }
            })
        }
    })
  })();